import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setCollabMcqResultsModalVisibility,
    setCollabMcqResults,
    setCollabIdMcqResults,
    getCollabMcqResults,
    setLastResponseNumber,
    getCollabResponseHistory,
    setResponseDatesHistory,
} from "../../vcompSlice";
import Langs from "../../../../app/lang/langs";
import moment from "moment";

import {
    Dialog,
    Slide,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Chip,
    Select,
    MenuItem,
    FormControl,
    Button,
    Divider,
    keyframes,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// --- Keyframe animations ---
const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const subtleGlow = keyframes`
    0%, 100% {
        box-shadow: 0 0 8px rgba(255, 144, 21, 0.15);
    }
    50% {
        box-shadow: 0 0 16px rgba(255, 144, 21, 0.3);
    }
`;

const shimmerPulse = keyframes`
    0%, 100% {
        opacity: 0.85;
    }
    50% {
        opacity: 1;
    }
`;

export default function MobileMcqResultsModal() {
    const dispatch = useDispatch();

    const visible = useSelector((state) => state.vcomp.collabMcqResultsModalVisibility);
    const idCollab = useSelector((state) => state.vcomp.collabIdMcqResults);
    const project = useSelector((state) => state.vcomp.onCreateProject);
    const results = useSelector((state) => state.vcomp.collabMcqResults);
    const lastResponse = useSelector((state) => state.vcomp.lastResponseNumber);
    const responseHistory = useSelector((state) => state.vcomp.responsesDatesHistory);

    const [selectedResponse, setSelectedResponse] = useState(null);
    const [totalScore, setTotalScore] = useState(0);

    // Fetch data when modal opens
    useEffect(() => {
        if (idCollab && project && project.id && lastResponse && lastResponse.response_number) {
            dispatch(getCollabMcqResults({ id_project: project.id, id_collab: idCollab, response_number: lastResponse.response_number }));
            dispatch(getCollabResponseHistory({ id_project: project.id, id_collab: idCollab }));
        }
    }, [idCollab, visible]);

    // Auto-select first response from history
    useEffect(() => {
        if (responseHistory.length > 0) {
            setSelectedResponse(responseHistory[0]);
        }
    }, [responseHistory]);

    // Calculate total score
    useEffect(() => {
        if (results.length > 0) {
            let score = 0;
            results.forEach((apt) => {
                score = score + apt.score;
            });
            score = score / results.length;
            setTotalScore(parseFloat(score).toFixed(2));
        } else {
            setTotalScore(0);
        }
    }, [results]);

    // Response history dropdown change handler
    const handleResponseNumberChange = (e) => {
        const value = e.target.value;
        const selected = responseHistory.find((r) => r.response_number === value);
        setSelectedResponse(selected);
        if (idCollab && project && project.id && selected && selected.response_number != null) {
            dispatch(getCollabMcqResults({ id_project: project.id, id_collab: idCollab, response_number: selected.response_number }));
        }
    };

    // Close handler - resets all state
    const handleClose = () => {
        dispatch(setCollabMcqResultsModalVisibility(false));
        dispatch(setCollabIdMcqResults(null));
        dispatch(setCollabMcqResults([]));
        dispatch(setLastResponseNumber(null));
        dispatch(setResponseDatesHistory([]));
        setSelectedResponse(null);
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        return moment(dateStr).format("HH[h]mm | DD/MM/YYYY");
    };

    const safeIncludes = (arr, id) => (Array.isArray(arr) ? arr : []).includes(id);

    const getOptionStyle = (option, question) => {
        const isCorrect = safeIncludes(question.correct_answers, option.id);
        const isCollabResponse = safeIncludes(question.collab_response, option.id);

        if (isCollabResponse && isCorrect) {
            return {
                bgcolor: "rgba(46, 125, 50, 0.08)",
                border: "1.5px solid rgba(46, 125, 50, 0.5)",
                color: "#2e7d32",
                boxShadow: "0 2px 8px rgba(46, 125, 50, 0.12), inset 0 0 0 1px rgba(46, 125, 50, 0.06)",
            };
        }
        if (isCollabResponse && !isCorrect) {
            return {
                bgcolor: "rgba(211, 47, 47, 0.06)",
                border: "1.5px solid rgba(211, 47, 47, 0.45)",
                color: "#d32f2f",
                boxShadow: "0 2px 8px rgba(211, 47, 47, 0.1), inset 0 0 0 1px rgba(211, 47, 47, 0.05)",
            };
        }
        if (isCorrect) {
            return {
                bgcolor: "rgba(46, 125, 50, 0.04)",
                border: "1.5px solid rgba(46, 125, 50, 0.25)",
                color: "#2e7d32",
                boxShadow: "none",
            };
        }
        return {
            bgcolor: "rgba(255, 255, 255, 0.7)",
            border: "1.5px solid rgba(0,0,0,0.07)",
            color: "#4b5263",
            boxShadow: "none",
        };
    };

    const getOptionIcon = (option, question) => {
        const isCorrect = safeIncludes(question.correct_answers, option.id);
        const isCollabResponse = safeIncludes(question.collab_response, option.id);

        if (isCollabResponse && isCorrect) {
            return <CheckCircleIcon sx={{ fontSize: 20, color: "#2e7d32", filter: "drop-shadow(0 1px 3px rgba(46, 125, 50, 0.3))" }} />;
        }
        if (isCollabResponse && !isCorrect) {
            return <CancelIcon sx={{ fontSize: 20, color: "#d32f2f", filter: "drop-shadow(0 1px 3px rgba(211, 47, 47, 0.3))" }} />;
        }
        if (isCorrect) {
            return <CheckCircleIcon sx={{ fontSize: 20, color: "rgba(46, 125, 50, 0.45)" }} />;
        }
        return <RadioButtonUncheckedIcon sx={{ fontSize: 20, color: "rgba(0,0,0,0.18)" }} />;
    };

    // Stagger delay helper
    const staggerDelay = (index) => `${120 + index * 80}ms`;
    const questionStaggerDelay = (aptIdx, qIdx) => `${200 + aptIdx * 100 + qIdx * 60}ms`;

    return (
        <Dialog
            fullScreen
            open={visible || false}
            onClose={handleClose}
            TransitionComponent={Transition}
            sx={{ zIndex: 1500 }}
        >
            {/* Sticky AppBar - Glassmorphic */}
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    bgcolor: "rgba(255, 255, 255, 0.82)",
                    backdropFilter: "blur(20px) saturate(1.8)",
                    WebkitBackdropFilter: "blur(20px) saturate(1.8)",
                    borderBottom: "1px solid rgba(255, 144, 21, 0.1)",
                }}
            >
                <Toolbar sx={{ justifyContent: "space-between", minHeight: 56 }}>
                    <IconButton
                        edge="start"
                        onClick={handleClose}
                        sx={{
                            color: "#4b5263",
                            transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                color: "#FF9015",
                                bgcolor: "rgba(255, 144, 21, 0.08)",
                            },
                            "&:active": {
                                transform: "scale(0.92)",
                            },
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 700,
                            color: "#111318",
                            textAlign: "center",
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            letterSpacing: "-0.02em",
                            fontSize: "1.05rem",
                        }}
                    >
                        Résultats MCQ
                    </Typography>
                    {/* Spacer to center the title */}
                    <Box sx={{ width: 48 }} />
                </Toolbar>

                {/* Total Score - prominent display */}
                <Box
                    sx={{
                        px: 2,
                        pb: 1.5,
                        pt: 0.5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            color: "rgba(0, 0, 0, 0.55)",
                            letterSpacing: "0.02em",
                        }}
                    >
                        Total Score :
                    </Typography>
                    <Box
                        sx={{
                            px: 2.5,
                            py: 0.75,
                            borderRadius: "12px",
                            bgcolor: parseFloat(totalScore) >= 50 ? "rgba(46, 125, 50, 0.08)" : "rgba(211, 47, 47, 0.08)",
                            border: "1px solid",
                            borderColor: parseFloat(totalScore) >= 50 ? "rgba(46, 125, 50, 0.2)" : "rgba(211, 47, 47, 0.2)",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "1.25rem",
                                fontWeight: 800,
                                color: parseFloat(totalScore) >= 50 ? "#2e7d32" : "#d32f2f",
                                letterSpacing: "-0.02em",
                            }}
                        >
                            {totalScore}%
                        </Typography>
                    </Box>
                </Box>

                {/* Response history selector */}
                <Box sx={{ px: 2, pb: 1.5 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            mb: 0.75,
                            fontWeight: 600,
                            color: "rgba(0, 0, 0, 0.5)",
                            fontSize: "0.72rem",
                            letterSpacing: "0.04em",
                            textTransform: "uppercase",
                        }}
                    >
                        Historique des tentatives ({responseHistory.length})
                    </Typography>
                    {responseHistory.length > 0 ? (
                        <FormControl fullWidth size="small">
                            <Select
                                value={selectedResponse ? selectedResponse.response_number : ""}
                                onChange={handleResponseNumberChange}
                                displayEmpty
                                sx={{
                                    fontSize: "16px",
                                    borderRadius: "12px",
                                    bgcolor: "rgba(255, 144, 21, 0.04)",
                                    border: "1px solid rgba(255, 144, 21, 0.12)",
                                    transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                                    "& .MuiSelect-select": {
                                        py: 1.2,
                                        fontSize: "16px",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&:hover": {
                                        bgcolor: "rgba(255, 144, 21, 0.07)",
                                        border: "1px solid rgba(255, 144, 21, 0.22)",
                                    },
                                    "&.Mui-focused": {
                                        bgcolor: "rgba(255, 144, 21, 0.06)",
                                        border: "1px solid rgba(255, 144, 21, 0.35)",
                                        boxShadow: "0 0 0 3px rgba(255, 144, 21, 0.1)",
                                    },
                                }}
                                MenuProps={{
                                    sx: { zIndex: 1600 },
                                    PaperProps: {
                                        sx: {
                                            borderRadius: "14px",
                                            boxShadow: "0 8px 32px rgba(255, 144, 21, 0.12), 0 2px 8px rgba(0,0,0,0.06)",
                                            border: "1px solid rgba(255, 144, 21, 0.08)",
                                            mt: 0.5,
                                            backdropFilter: "blur(12px)",
                                        },
                                    },
                                }}
                            >
                                {responseHistory.map((resp) => (
                                    <MenuItem
                                        key={resp.response_number}
                                        value={resp.response_number}
                                        sx={{
                                            borderRadius: "8px",
                                            mx: 0.5,
                                            my: 0.25,
                                            transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                                            "&:hover": {
                                                bgcolor: "rgba(255, 144, 21, 0.08)",
                                            },
                                            "&.Mui-selected": {
                                                bgcolor: "rgba(255, 144, 21, 0.1)",
                                                "&:hover": {
                                                    bgcolor: "rgba(255, 144, 21, 0.14)",
                                                },
                                            },
                                        }}
                                    >
                                        {formatDate(resp.created_at)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    ) : (
                        <Box
                            sx={{
                                py: 1.5,
                                px: 2,
                                borderRadius: "12px",
                                bgcolor: "rgba(0, 0, 0, 0.03)",
                                border: "1px solid rgba(0, 0, 0, 0.06)",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "0.85rem",
                                    color: "rgba(0, 0, 0, 0.4)",
                                    fontStyle: "italic",
                                }}
                            >
                                Aucun historique disponible
                            </Typography>
                        </Box>
                    )}
                </Box>
            </AppBar>

            {/* Scrollable results body */}
            <Box
                sx={{
                    mt: 0,
                    flex: 1,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    bgcolor: "#f8f9fb",
                    pb: "100px",
                    scrollBehavior: "smooth",
                    /* Custom thin scrollbar */
                    "&::-webkit-scrollbar": {
                        width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "rgba(255, 144, 21, 0.2)",
                        borderRadius: "3px",
                    },
                }}
            >
                {results.length === 0 ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: 200,
                            animation: `${fadeSlideUp} 400ms cubic-bezier(0, 0, 0.2, 1) forwards`,
                        }}
                    >
                        <Typography variant="body2" sx={{ color: "#8b92a0", letterSpacing: "0.01em" }}>
                            Aucun résultat disponible
                        </Typography>
                    </Box>
                ) : (
                    results.map((aptitude, aptIdx) => (
                        <Box
                            key={aptitude.id}
                            sx={{
                                mb: 2,
                                opacity: 0,
                                animation: `${fadeSlideUp} 500ms cubic-bezier(0, 0, 0.2, 1) ${staggerDelay(aptIdx)} forwards`,
                            }}
                        >
                            {/* Aptitude header card - Glassmorphic */}
                            <Box
                                sx={{
                                    mx: 2,
                                    mt: 2.5,
                                    p: 2.5,
                                    bgcolor: "rgba(255, 255, 255, 0.75)",
                                    backdropFilter: "blur(12px)",
                                    WebkitBackdropFilter: "blur(12px)",
                                    borderRadius: "16px",
                                    boxShadow: "0 2px 12px rgba(255, 144, 21, 0.08), 0 1px 4px rgba(0,0,0,0.04)",
                                    border: "1px solid rgba(255, 144, 21, 0.1)",
                                    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                                }}
                            >
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 0.5 }}>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#111318",
                                            flex: 1,
                                            mr: 1,
                                            letterSpacing: "-0.02em",
                                            fontSize: "1.05rem",
                                        }}
                                    >
                                        {aptitude.nom}
                                    </Typography>
                                    {aptitude.score !== null && (
                                        <Chip
                                            label={`${parseFloat(aptitude.score).toFixed(2)}%`}
                                            size="small"
                                            sx={{
                                                fontWeight: 700,
                                                fontSize: "0.82rem",
                                                bgcolor: parseFloat(aptitude.score) >= 50 ? "rgba(46, 125, 50, 0.1)" : "rgba(211, 47, 47, 0.1)",
                                                color: parseFloat(aptitude.score) >= 50 ? "#2e7d32" : "#d32f2f",
                                                flexShrink: 0,
                                                animation: `${subtleGlow} 4s ease-in-out infinite`,
                                                boxShadow: parseFloat(aptitude.score) >= 50
                                                    ? "0 2px 8px rgba(46, 125, 50, 0.15)"
                                                    : "0 2px 8px rgba(211, 47, 47, 0.15)",
                                                letterSpacing: "0.02em",
                                                border: "none",
                                            }}
                                        />
                                    )}
                                </Box>
                                {aptitude.description && (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#6b7280",
                                            lineHeight: 1.6,
                                            mt: 0.5,
                                            fontWeight: 400,
                                            letterSpacing: "0.005em",
                                        }}
                                    >
                                        {aptitude.description}
                                    </Typography>
                                )}
                            </Box>

                            {/* Questions within aptitude */}
                            {aptitude.questions && aptitude.questions.map((question, qIdx) => (
                                <Box
                                    key={question.id}
                                    sx={{
                                        mx: 2,
                                        mt: 1.5,
                                        p: 2,
                                        bgcolor: "rgba(255, 255, 255, 0.7)",
                                        backdropFilter: "blur(8px)",
                                        WebkitBackdropFilter: "blur(8px)",
                                        borderRadius: "14px",
                                        boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
                                        borderLeft: "3px solid",
                                        borderLeftColor: question.score !== null && question.score > 0
                                            ? "rgba(46, 125, 50, 0.7)"
                                            : "rgba(211, 47, 47, 0.7)",
                                        border: "1px solid rgba(0,0,0,0.04)",
                                        borderLeftWidth: "3px",
                                        borderLeftStyle: "solid",
                                        transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1)",
                                        opacity: 0,
                                        animation: `${fadeSlideUp} 450ms cubic-bezier(0, 0, 0.2, 1) ${questionStaggerDelay(aptIdx, qIdx)} forwards`,
                                    }}
                                >
                                    {/* Question text */}
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontWeight: 600,
                                            color: "#111318",
                                            mb: 0.5,
                                            fontSize: "0.95rem",
                                            letterSpacing: "-0.01em",
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        {question.question}
                                    </Typography>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
                                        {question.response_date && (
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: "#8b92a0",
                                                    fontWeight: 400,
                                                    letterSpacing: "0.02em",
                                                }}
                                            >
                                                {formatDate(question.response_date)}
                                            </Typography>
                                        )}
                                        {question.score !== null && (
                                            <Chip
                                                label={`Score: ${question.score}`}
                                                size="small"
                                                variant="outlined"
                                                sx={{
                                                    fontSize: "0.7rem",
                                                    height: 24,
                                                    borderColor: question.score > 0
                                                        ? "rgba(46, 125, 50, 0.4)"
                                                        : "rgba(211, 47, 47, 0.4)",
                                                    color: question.score > 0 ? "#2e7d32" : "#d32f2f",
                                                    fontWeight: 600,
                                                    letterSpacing: "0.03em",
                                                    bgcolor: question.score > 0
                                                        ? "rgba(46, 125, 50, 0.05)"
                                                        : "rgba(211, 47, 47, 0.05)",
                                                    boxShadow: question.score > 0
                                                        ? "0 1px 4px rgba(46, 125, 50, 0.1)"
                                                        : "0 1px 4px rgba(211, 47, 47, 0.1)",
                                                }}
                                            />
                                        )}
                                    </Box>

                                    {/* Legend */}
                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
                                        <Chip
                                            icon={<CheckCircleIcon sx={{ fontSize: 14 }} />}
                                            label="Bonne réponse"
                                            size="small"
                                            sx={{
                                                height: 24, fontSize: "0.68rem", fontWeight: 600,
                                                bgcolor: "rgba(46, 125, 50, 0.08)", color: "#2e7d32",
                                                border: "1px solid rgba(46, 125, 50, 0.15)",
                                                "& .MuiChip-icon": { color: "#4caf50" },
                                            }}
                                        />
                                        {safeIncludes(question.collab_response, question.collab_response?.[0]) && (
                                            <Chip
                                                label="Sa réponse"
                                                size="small"
                                                sx={{
                                                    height: 24, fontSize: "0.68rem", fontWeight: 600,
                                                    bgcolor: "rgba(255, 144, 21, 0.08)", color: "#FF9015",
                                                    border: "1px solid rgba(255, 144, 21, 0.15)",
                                                }}
                                            />
                                        )}
                                    </Box>

                                    {/* Options list */}
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                        {question.options.map((option) => {
                                            const optStyles = getOptionStyle(option, question);
                                            const isCollab = safeIncludes(question.collab_response, option.id);
                                            const isCorrect = safeIncludes(question.correct_answers, option.id);
                                            return (
                                                <Box
                                                    key={option.id}
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1.2,
                                                        p: 1.4,
                                                        borderRadius: "12px",
                                                        ...optStyles,
                                                        transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                                                        "&:active": {
                                                            transform: "scale(0.98)",
                                                        },
                                                    }}
                                                >
                                                    {getOptionIcon(option, question)}
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: optStyles.color,
                                                                fontWeight: (isCorrect || isCollab) ? 600 : 400,
                                                                lineHeight: 1.5,
                                                                letterSpacing: "0.005em",
                                                            }}
                                                        >
                                                            {option.value}
                                                        </Typography>
                                                        {isCollab && (
                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    color: isCorrect ? "#2e7d32" : "#d32f2f",
                                                                    fontWeight: 700,
                                                                    fontSize: "0.65rem",
                                                                    letterSpacing: "0.03em",
                                                                    textTransform: "uppercase",
                                                                    mt: 0.25,
                                                                    display: "block",
                                                                }}
                                                            >
                                                                {isCorrect ? "✓ Sa réponse (correcte)" : "✗ Sa réponse (incorrecte)"}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            ))}

                            {/* Refined divider */}
                            <Divider
                                sx={{
                                    mx: 3,
                                    mt: 2.5,
                                    borderColor: "rgba(255, 144, 21, 0.08)",
                                }}
                            />
                        </Box>
                    ))
                )}
            </Box>

            {/* Sticky bottom close button - Glassmorphic */}
            <Box
                sx={{
                    position: "sticky",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    p: 2,
                    pb: "calc(env(safe-area-inset-bottom, 8px) + 16px)",
                    background: "linear-gradient(to top, rgba(255,255,255,0.95) 60%, rgba(255,255,255,0.7) 100%)",
                    backdropFilter: "blur(24px) saturate(1.8)",
                    WebkitBackdropFilter: "blur(24px) saturate(1.8)",
                    borderTop: "1px solid rgba(255, 144, 21, 0.12)",
                    zIndex: 1,
                }}
            >
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleClose}
                    sx={{
                        background: "linear-gradient(135deg, #FF9015 0%, #FFC100 100%)",
                        color: "#fff",
                        borderRadius: 999,
                        minHeight: 50,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "1rem",
                        letterSpacing: "0.02em",
                        boxShadow: "0 4px 16px rgba(255, 144, 21, 0.35), 0 1px 4px rgba(255, 144, 21, 0.2)",
                        transition: "all 280ms cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                            background: "linear-gradient(135deg, #e87e00 0%, #FFB000 100%)",
                            boxShadow: "0 6px 24px rgba(255, 144, 21, 0.45), 0 2px 6px rgba(255, 144, 21, 0.25)",
                            transform: "scale(1.02)",
                        },
                        "&:active": {
                            transform: "scale(0.97)",
                            boxShadow: "0 2px 8px rgba(255, 144, 21, 0.3)",
                        },
                    }}
                >
                    <Langs str="CLOSE" />
                </Button>
            </Box>
        </Dialog>
    );
}
